import React from 'react'
import createIcon from '@/lib/create-icon'

export const CubeSVGIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_532_3710)">
      <path d="M1.54637 4.10668L7.99971 7.33335M7.99971 7.33335L14.453 4.10668M7.99971 7.33335V15.1734M8.59304 0.966685L13.9264 3.63335C14.1485 3.74374 14.3355 3.9139 14.4662 4.12471C14.5969 4.33553 14.6662 4.57863 14.6664 4.82668V11.18C14.6662 11.4281 14.5969 11.6712 14.4662 11.882C14.3355 12.0928 14.1485 12.263 13.9264 12.3734L8.59304 15.04C8.4078 15.1327 8.20351 15.181 7.99637 15.181C7.78924 15.181 7.58495 15.1327 7.39971 15.04L2.06637 12.3734C1.84446 12.2615 1.65821 12.0899 1.52863 11.8779C1.39906 11.6659 1.33131 11.4218 1.33304 11.1734V4.82668C1.33317 4.57863 1.4025 4.33553 1.53323 4.12471C1.66395 3.9139 1.8509 3.74374 2.07304 3.63335L7.40637 0.966685C7.59074 0.875069 7.79383 0.827393 7.99971 0.827393C8.20559 0.827393 8.40867 0.875069 8.59304 0.966685Z" stroke="#0B947C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_532_3710">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,

)
